import { tempoApi } from '@/lib/api/tempoApi';
import type { ItemType, ItemTypeUpsert } from '@/lib/api/types/itemType';

const getItemTypes = async (): Promise<ItemType[]> =>
  await tempoApi().get('api/v1/item-store/item-types').json<ItemType[]>();

const updateItemType = async (
  params: { itemTypeId: number },
  data: ItemTypeUpsert,
): Promise<ItemType> =>
  await tempoApi()
    .put(`api/v1/item-store/item-types/${params.itemTypeId}`, { json: data })
    .json<ItemType>();

const updateItemTypeLevelId = async (
  params: { itemTypeId: number },
  data: { itemLevelId: number },
): Promise<ItemType> =>
  await tempoApi()
    .patch(`api/v1/item-store/item-types/${params.itemTypeId}`, { json: data })
    .json<ItemType>();

export const bulkUpsertItemTypes = async (itemTypes: ItemTypeUpsert[]): Promise<ItemType[]> =>
  await tempoApi()
    .post('api/v1/item-store/item-types/bulk', { json: itemTypes })
    .json<ItemType[]>();

const getDeletableItemTypeIds = async (): Promise<number[]> =>
  await tempoApi().get('api/v1/item-store/item-types/deletable').json<number[]>();

const deleteItemType = async (params: { itemTypeId: number }): Promise<void> => {
  await tempoApi().delete(`api/v1/item-store/item-types/${params.itemTypeId}`);
};

export const ItemTypeApi = {
  getItemTypes,
  bulkUpsertItemTypes,
  updateItemType,
  updateItemTypeLevelId,
  getDeletableItemTypeIds,
  deleteItemType,
} as const;
